import { EMPTY_STRING } from '@constants';

export const checkString = (value?: string) => value ?? EMPTY_STRING;
